import { alpha } from "@mui/system";

const styles = (theme) => ({
  terminalContainer: {
    width: "100%",
    height: "100%",
    minWidth: 0,
    flex: 1,
    minHeight: 0,
    position: "absolute",
    padding: "8px",
    paddingBottom: "16px",
    overflow: "hidden", // Impede rolagem dupla (container)
    background:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark, 0.4)
        : theme.palette.colors.black.lighter,
  },
  terminalDiv: {
    width: "100%",
    height: "100%",
  },
  terminalTheme: {
    background:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark, 0.4)
        : theme.palette.colors.black.lighter,
    foreground:
      theme.palette.mode === "dark"
        ? theme.palette.colors.white.dark
        : theme.palette.colors.black.dark,
    cursor:
      theme.palette.mode === "dark"
        ? theme.palette.secondary.main
        : alpha(theme.palette.secondary.main, 0.6),
    selectionBackground:
      theme.palette.mode === "dark"
        ? theme.palette.secondary.main
        : alpha(theme.palette.secondary.main, 0.6),
  },
  xtermCustom: {
    "& .xterm-viewport": {
      overflowY: "auto !important",
    },
    "& .xterm-custom-container": {
      padding: "8px",
    },
    "& .xterm, .xterm-viewport, .xterm-screen": {
      background: "transparent !important",
    },
  },
});

export default styles;
